export default __webpack_public_path__ + "static/media/01.2f591a82.svg";